import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import Loading from 'modules/layout/components/Page/Loading'

import { apiClient } from '../../core/lib/mobx-rest'
import UnifiedAddEmployeeModal from '../components/UnifiedAddEmployeeModal'

const AddEmployeePage = () => {
  const [submitting, setSubmitting] = React.useState(false)
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.employees.list.fullPath())
  }

  const source = { sourceType: 'employee_list' }

  const onSuccess = async (employeeId: number) => {
    setSubmitting(true)
    cleanMemberships() // In order to refresh teams section properly
    navigate(navigation.employees.id.fullPath({ id: employeeId }))
  }

  const cleanMemberships = () => {
    const client = apiClient()

    client.cache.evict('memberships')
  }

  if (submitting) {
    return <Loading />
  }

  return <UnifiedAddEmployeeModal onClose={onClose} source={source} onSuccess={onSuccess} />
}

export default AddEmployeePage
